function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0z" /><path d="M21 13.24V20h1v2H2v-2h1v-6.76A4.5 4.5 0 0 1 1 9.5c0-.83.22-1.62.63-2.3l2.71-4.7a1 1 0 0 1 .87-.5H18.8a1 1 0 0 1 .87.5l2.7 4.68A4.5 4.5 0 0 1 21 13.24zm-2 .73a4.5 4.5 0 0 1-3.75-1.36 4.5 4.5 0 0 1-3.25 1.4 4.5 4.5 0 0 1-3.25-1.4A4.5 4.5 0 0 1 5 13.97V20h14v-6.03zM5.79 4L3.36 8.21a2.5 2.5 0 0 0 4.46 2.22 1 1 0 0 1 1.86 0 2.5 2.5 0 0 0 4.64 0 1 1 0 0 1 1.86 0 2.5 2.5 0 1 0 4.46-2.23L18.2 4H5.79z" /></svg>;
});